// 存储管理器

const STORAGE_KEYS = {
  WINDOW_STATE: 'floating-chat-window-state',
  UNREAD_COUNT: 'floating-chat-unread-count',
  USER_PREFS: 'floating-chat-user-prefs',
} as const;

export class StorageManager {
  private enabled: boolean;

  constructor(enabled: boolean = true) {
    this.enabled = enabled && this.isLocalStorageAvailable();
  }

  private isLocalStorageAvailable(): boolean {
    try {
      const test = '__storage_test__';
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }
  }

  public saveWindowState(isOpen: boolean): void {
    if (!this.enabled) return;

    try {
      localStorage.setItem(STORAGE_KEYS.WINDOW_STATE, JSON.stringify({ isOpen }));
    } catch (error) {
      console.warn('FloatingChat: Failed to save window state', error);
    }
  }

  public getWindowState(): { isOpen: boolean } | null {
    if (!this.enabled) return null;

    try {
      const data = localStorage.getItem(STORAGE_KEYS.WINDOW_STATE);
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.warn('FloatingChat: Failed to get window state', error);
      return null;
    }
  }

  public saveUnreadCount(count: number): void {
    if (!this.enabled) return;

    try {
      localStorage.setItem(STORAGE_KEYS.UNREAD_COUNT, String(count));
    } catch (error) {
      console.warn('FloatingChat: Failed to save unread count', error);
    }
  }

  public getUnreadCount(): number {
    if (!this.enabled) return 0;

    try {
      const count = localStorage.getItem(STORAGE_KEYS.UNREAD_COUNT);
      return count ? parseInt(count, 10) : 0;
    } catch (error) {
      console.warn('FloatingChat: Failed to get unread count', error);
      return 0;
    }
  }

  public saveUserPrefs(prefs: Record<string, any>): void {
    if (!this.enabled) return;

    try {
      localStorage.setItem(STORAGE_KEYS.USER_PREFS, JSON.stringify(prefs));
    } catch (error) {
      console.warn('FloatingChat: Failed to save user prefs', error);
    }
  }

  public getUserPrefs(): Record<string, any> | null {
    if (!this.enabled) return null;

    try {
      const data = localStorage.getItem(STORAGE_KEYS.USER_PREFS);
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.warn('FloatingChat: Failed to get user prefs', error);
      return null;
    }
  }

  public clear(): void {
    if (!this.enabled) return;

    try {
      Object.values(STORAGE_KEYS).forEach(key => {
        localStorage.removeItem(key);
      });
    } catch (error) {
      console.warn('FloatingChat: Failed to clear storage', error);
    }
  }
}
